module.exports = __webpack_public_path__ + "loading.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.png
// module id = 1908
// module chunks = 0